export const RecentsFilter = ({
	showRecents,
	handleShowRecentsToggle,
	disabled,
}: {
	showRecents: boolean;
	handleShowRecentsToggle: () => void;
	disabled?: boolean;
}) => {
	return (
		<div className="checkbox-wrapper">
			<label
				htmlFor={"recent-filter"}
				className={disabled ? "label-disabled" : ""}
			>
				Filter Recents
			</label>
			<input
				id={"recent-filter"}
				type={"checkbox"}
				disabled={disabled}
				className={"checkbox"}
				checked={showRecents}
				onChange={handleShowRecentsToggle}
			/>
			{/** biome-ignore lint/a11y/noLabelWithoutControl: This is a required label for the class of Toggle */}
			<label htmlFor="recent-filter" className="toggle" />
		</div>
	);
};
